import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../client/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_39afd83c from 'nuxt_plugin_sentryserver_39afd83c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7d6ea25a from 'nuxt_plugin_sentryclient_7d6ea25a' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_distplugin42274221_b4bfcbf2 from 'nuxt_plugin_distplugin42274221_b4bfcbf2' // Source: ./dist.plugin.42274221.js (mode: 'client')
import nuxt_plugin_portalvue_28d43cf5 from 'nuxt_plugin_portalvue_28d43cf5' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_router_40937d51 from 'nuxt_plugin_router_40937d51' // Source: ./router.js (mode: 'all')
import nuxt_plugin_axios_7823521e from 'nuxt_plugin_axios_7823521e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_arepui_d6b61b30 from 'nuxt_plugin_arepui_d6b61b30' // Source: ../client/plugins/arep-ui.js (mode: 'all')
import nuxt_plugin_arapi_9187ed8a from 'nuxt_plugin_arapi_9187ed8a' // Source: ../client/plugins/ar-api (mode: 'all')
import nuxt_plugin_arcomponents_4b4799fb from 'nuxt_plugin_arcomponents_4b4799fb' // Source: ../client/plugins/ar-components.js (mode: 'all')
import nuxt_plugin_arga_309203b7 from 'nuxt_plugin_arga_309203b7' // Source: ../client/plugins/ar-ga.js (mode: 'client')
import nuxt_plugin_arhubspot_32292286 from 'nuxt_plugin_arhubspot_32292286' // Source: ../client/plugins/ar-hubspot.js (mode: 'all')
import nuxt_plugin_arpendo_174250f9 from 'nuxt_plugin_arpendo_174250f9' // Source: ../client/plugins/ar-pendo.js (mode: 'all')
import nuxt_plugin_arfeaturemask_4a181806 from 'nuxt_plugin_arfeaturemask_4a181806' // Source: ../client/plugins/ar-feature-mask (mode: 'all')
import nuxt_plugin_arnotification_315ad77e from 'nuxt_plugin_arnotification_315ad77e' // Source: ../client/plugins/ar-notification (mode: 'all')
import nuxt_plugin_arutils_0a8e37f8 from 'nuxt_plugin_arutils_0a8e37f8' // Source: ../client/plugins/ar-utils (mode: 'all')
import nuxt_plugin_arhotkey_376f2d50 from 'nuxt_plugin_arhotkey_376f2d50' // Source: ../client/plugins/ar-hotkey (mode: 'all')
import nuxt_plugin_arstickytop_3bd62fc0 from 'nuxt_plugin_arstickytop_3bd62fc0' // Source: ../client/plugins/ar-sticky-top.js (mode: 'all')
import nuxt_plugin_arfilters_f110e8fc from 'nuxt_plugin_arfilters_f110e8fc' // Source: ../client/plugins/ar-filters.js (mode: 'all')
import nuxt_plugin_arfuzzysearch_a53f6648 from 'nuxt_plugin_arfuzzysearch_a53f6648' // Source: ../client/plugins/ar-fuzzy-search.ts (mode: 'all')
import nuxt_plugin_araxios_3388a046 from 'nuxt_plugin_araxios_3388a046' // Source: ../client/plugins/ar-axios.ts (mode: 'all')
import nuxt_plugin_githashclient_48d7019e from 'nuxt_plugin_githashclient_48d7019e' // Source: ../client/plugins/git-hash-client.js (mode: 'all')
import nuxt_plugin_init_5aefaeb1 from 'nuxt_plugin_init_5aefaeb1' // Source: ../client/plugins/init.js (mode: 'all')
import nuxt_plugin_vueportal_5154face from 'nuxt_plugin_vueportal_5154face' // Source: ../client/plugins/vue-portal.js (mode: 'all')
import nuxt_plugin_vuedraggable_5738acb2 from 'nuxt_plugin_vuedraggable_5738acb2' // Source: ../client/plugins/vue-draggable.js (mode: 'all')
import nuxt_plugin_vueleaderline_95ac48c6 from 'nuxt_plugin_vueleaderline_95ac48c6' // Source: ../client/plugins/vue-leaderline.js (mode: 'all')
import nuxt_plugin_vuescrollto_44ce9a1c from 'nuxt_plugin_vuescrollto_44ce9a1c' // Source: ../client/plugins/vue-scrollto.js (mode: 'all')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ../client/plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_vuecroppie_3ca70318 from 'nuxt_plugin_vuecroppie_3ca70318' // Source: ../client/plugins/vue-croppie.js (mode: 'all')
import nuxt_plugin_vueinfinitescroll_4479822e from 'nuxt_plugin_vueinfinitescroll_4479822e' // Source: ../client/plugins/vue-infinite-scroll.js (mode: 'all')
import nuxt_plugin_vtooltip_3d258741 from 'nuxt_plugin_vtooltip_3d258741' // Source: ../client/plugins/v-tooltip.js (mode: 'all')
import nuxt_plugin_vclickoutside_12eb1bf8 from 'nuxt_plugin_vclickoutside_12eb1bf8' // Source: ../client/plugins/v-click-outside.js (mode: 'all')
import nuxt_plugin_isbrowser_5605f29c from 'nuxt_plugin_isbrowser_5605f29c' // Source: ../client/plugins/is-browser.js (mode: 'all')
import nuxt_plugin_arwebworker_daf92f5c from 'nuxt_plugin_arwebworker_daf92f5c' // Source: ../client/plugins/ar-web-worker (mode: 'client')
import nuxt_plugin_vueinputautowidth_22368a81 from 'nuxt_plugin_vueinputautowidth_22368a81' // Source: ../client/plugins/vue-input-autowidth.js (mode: 'client')
import nuxt_plugin_vueapexcharts_046160bc from 'nuxt_plugin_vueapexcharts_046160bc' // Source: ../client/plugins/vue-apexcharts.js (mode: 'client')
import nuxt_plugin_oneschema_a8455332 from 'nuxt_plugin_oneschema_a8455332' // Source: ../client/plugins/oneschema.js (mode: 'all')
import nuxt_plugin_posthog_717c402e from 'nuxt_plugin_posthog_717c402e' // Source: ../client/plugins/posthog (mode: 'client')
import nuxt_plugin_intercomfin_370a3606 from 'nuxt_plugin_intercomfin_370a3606' // Source: ../client/plugins/intercom-fin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Audience Republic","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"theme-color","content":"#7344c0"},{"name":"msapplication-navbutton-color","content":"#7344c0"},{"hid":"description","name":"description","content":"Set up campaigns to make your event go viral, driving sales to your existing ticketing provider."}],"link":[{"rel":"shortcut icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fcdn.arep.co\u002Fimg\u002Ffavicon\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_39afd83c === 'function') {
    await nuxt_plugin_sentryserver_39afd83c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7d6ea25a === 'function') {
    await nuxt_plugin_sentryclient_7d6ea25a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_distplugin42274221_b4bfcbf2 === 'function') {
    await nuxt_plugin_distplugin42274221_b4bfcbf2(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_28d43cf5 === 'function') {
    await nuxt_plugin_portalvue_28d43cf5(app.context, inject)
  }

  if (typeof nuxt_plugin_router_40937d51 === 'function') {
    await nuxt_plugin_router_40937d51(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7823521e === 'function') {
    await nuxt_plugin_axios_7823521e(app.context, inject)
  }

  if (typeof nuxt_plugin_arepui_d6b61b30 === 'function') {
    await nuxt_plugin_arepui_d6b61b30(app.context, inject)
  }

  if (typeof nuxt_plugin_arapi_9187ed8a === 'function') {
    await nuxt_plugin_arapi_9187ed8a(app.context, inject)
  }

  if (typeof nuxt_plugin_arcomponents_4b4799fb === 'function') {
    await nuxt_plugin_arcomponents_4b4799fb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_arga_309203b7 === 'function') {
    await nuxt_plugin_arga_309203b7(app.context, inject)
  }

  if (typeof nuxt_plugin_arhubspot_32292286 === 'function') {
    await nuxt_plugin_arhubspot_32292286(app.context, inject)
  }

  if (typeof nuxt_plugin_arpendo_174250f9 === 'function') {
    await nuxt_plugin_arpendo_174250f9(app.context, inject)
  }

  if (typeof nuxt_plugin_arfeaturemask_4a181806 === 'function') {
    await nuxt_plugin_arfeaturemask_4a181806(app.context, inject)
  }

  if (typeof nuxt_plugin_arnotification_315ad77e === 'function') {
    await nuxt_plugin_arnotification_315ad77e(app.context, inject)
  }

  if (typeof nuxt_plugin_arutils_0a8e37f8 === 'function') {
    await nuxt_plugin_arutils_0a8e37f8(app.context, inject)
  }

  if (typeof nuxt_plugin_arhotkey_376f2d50 === 'function') {
    await nuxt_plugin_arhotkey_376f2d50(app.context, inject)
  }

  if (typeof nuxt_plugin_arstickytop_3bd62fc0 === 'function') {
    await nuxt_plugin_arstickytop_3bd62fc0(app.context, inject)
  }

  if (typeof nuxt_plugin_arfilters_f110e8fc === 'function') {
    await nuxt_plugin_arfilters_f110e8fc(app.context, inject)
  }

  if (typeof nuxt_plugin_arfuzzysearch_a53f6648 === 'function') {
    await nuxt_plugin_arfuzzysearch_a53f6648(app.context, inject)
  }

  if (typeof nuxt_plugin_araxios_3388a046 === 'function') {
    await nuxt_plugin_araxios_3388a046(app.context, inject)
  }

  if (typeof nuxt_plugin_githashclient_48d7019e === 'function') {
    await nuxt_plugin_githashclient_48d7019e(app.context, inject)
  }

  if (typeof nuxt_plugin_init_5aefaeb1 === 'function') {
    await nuxt_plugin_init_5aefaeb1(app.context, inject)
  }

  if (typeof nuxt_plugin_vueportal_5154face === 'function') {
    await nuxt_plugin_vueportal_5154face(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedraggable_5738acb2 === 'function') {
    await nuxt_plugin_vuedraggable_5738acb2(app.context, inject)
  }

  if (typeof nuxt_plugin_vueleaderline_95ac48c6 === 'function') {
    await nuxt_plugin_vueleaderline_95ac48c6(app.context, inject)
  }

  if (typeof nuxt_plugin_vuescrollto_44ce9a1c === 'function') {
    await nuxt_plugin_vuescrollto_44ce9a1c(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (typeof nuxt_plugin_vuecroppie_3ca70318 === 'function') {
    await nuxt_plugin_vuecroppie_3ca70318(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinfinitescroll_4479822e === 'function') {
    await nuxt_plugin_vueinfinitescroll_4479822e(app.context, inject)
  }

  if (typeof nuxt_plugin_vtooltip_3d258741 === 'function') {
    await nuxt_plugin_vtooltip_3d258741(app.context, inject)
  }

  if (typeof nuxt_plugin_vclickoutside_12eb1bf8 === 'function') {
    await nuxt_plugin_vclickoutside_12eb1bf8(app.context, inject)
  }

  if (typeof nuxt_plugin_isbrowser_5605f29c === 'function') {
    await nuxt_plugin_isbrowser_5605f29c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_arwebworker_daf92f5c === 'function') {
    await nuxt_plugin_arwebworker_daf92f5c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinputautowidth_22368a81 === 'function') {
    await nuxt_plugin_vueinputautowidth_22368a81(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueapexcharts_046160bc === 'function') {
    await nuxt_plugin_vueapexcharts_046160bc(app.context, inject)
  }

  if (typeof nuxt_plugin_oneschema_a8455332 === 'function') {
    await nuxt_plugin_oneschema_a8455332(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_posthog_717c402e === 'function') {
    await nuxt_plugin_posthog_717c402e(app.context, inject)
  }

  if (typeof nuxt_plugin_intercomfin_370a3606 === 'function') {
    await nuxt_plugin_intercomfin_370a3606(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
